import {
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Drawer,
  IconButton
} from '@mui/material';
import React, { useState } from 'react';
import { SearchRequest, SUPPLIER_SEARCH_TARGET } from 'types/Search';
import { Filters } from '../SearchFilters/Filters';
import FilterListIcon from '@mui/icons-material/FilterList';
import { tss } from 'tss-react/mui';
import Close from '@mui/icons-material/Close';
import { FacetOrderSelector } from '../SearchFilters/FacetOrderSelector';
import { UnionCustomAttributeProps } from 'components/common/Portals/CustomAttributes/types';
import { SupplierFilterTarget } from 'helpers/Search';

interface Props {
  isLaPrairieEvent: boolean;
  searchRequest: SearchRequest;
  isBrandPortal: boolean;
  clearAllFilters: () => void;
  companyAttributeDefinitions?: UnionCustomAttributeProps[];
  productAttributeDefinitions?: UnionCustomAttributeProps[];
}
export const CovaloMobileFilters: React.FC<Props> = ({
  isLaPrairieEvent,
  clearAllFilters,
  searchRequest,
  isBrandPortal,
  companyAttributeDefinitions,
  productAttributeDefinitions
}) => {
  const [isCovaloMobileFilterOpen, setIsCovaloMobileFilterOpen] =
    useState(false);
  //on launch year we save them all in one field so the we cant really rely on filtelength when we have them included

  const filterLength = searchRequest.filters.length;
  const { classes } = useStyles();
  return (
    <>
      <Button
        variant="outlined"
        size="small"
        onClick={() => setIsCovaloMobileFilterOpen(true)}
        startIcon={<FilterListIcon fontSize="small" color="primary" />}
      >
        Select Filters
      </Button>
      {searchRequest.filters?.length > 0 && (
        <Chip
          label={`${filterLength} filter${
            filterLength > 1 ? 's' : ''
          } selected`}
          onDelete={clearAllFilters}
          color="primary"
        />
      )}
      <Drawer
        open={isCovaloMobileFilterOpen}
        onClose={() => setIsCovaloMobileFilterOpen(false)}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle
          sx={{
            width: '100%',
            position: 'sticky',
            top: 0,
            background: 'white',
            display: 'grid',
            padding: 0
          }}
        >
          <IconButton
            onClick={() => setIsCovaloMobileFilterOpen(false)}
            sx={{ justifySelf: 'flex-end' }}
          >
            <Close fontSize="small" />
          </IconButton>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mr: 1 }}>
            <FacetOrderSelector />
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ padding: 0 }}>
          <Filters
            supplierFilterTarget={
              searchRequest.target === SUPPLIER_SEARCH_TARGET
                ? SupplierFilterTarget.SUPPLIERS
                : undefined
            }
            isLaPrairieEvent={isLaPrairieEvent}
            isBrandPortal={isBrandPortal}
            companyAttributeDefinitions={companyAttributeDefinitions}
            productAttributeDefinitions={productAttributeDefinitions}
          />
          {searchRequest.target === SUPPLIER_SEARCH_TARGET && (
            <Box sx={{ mt: 2 }}>
              <Filters
                supplierFilterTarget={SupplierFilterTarget.INGREDIENTS}
                isBrandPortal={false}
                isLaPrairieEvent={false}
              />
            </Box>
          )}
        </DialogContent>
        <DialogActions
          sx={theme => ({
            padding: 0,
            position: 'sticky',
            bottom: 0,
            borderTop: `1px solid ${theme.palette.primary.main}`,
            boxShadow: theme.shadows[4]
          })}
        >
          {filterLength > 0 && (
            <Button
              variant="text"
              size="small"
              onClick={clearAllFilters}
              sx={{
                position: 'sticky',
                bottom: 0,
                background: 'white',
                margin: '0 auto'
              }}
            >
              Clear selected filter{filterLength > 1 ? 's' : ''}
            </Button>
          )}
        </DialogActions>
      </Drawer>
    </>
  );
};

const useStyles = tss.create(() => ({
  paper: {
    width: '70%'
  }
}));
